export default __webpack_public_path__ + "static/media/makeAdmin.d868cf6f.svg";